'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  margin-top: 24px;\n  align-items: center;\n'], ['\n  display: flex;\n  margin-top: 24px;\n  align-items: center;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Controls = _styledComponents2.default.div(_templateObject);
exports.default = Controls;


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactour/dist/components/Controls.js
// module id = 1874
// module chunks = 2